/**
 * The order tenants appear in, wherever a screen groups by BU.
 *
 * `water-platform` leads — it is the main tenant and the one people look at most, so it should not
 * drift down the page as other tenants are added. Everything else is alphabetical, which keeps the
 * order stable and predictable.
 *
 * Used by Páginas, Tours and What's New so the three screens agree.
 *
 * @module Shared/brand
 */

/** Tenants pinned to the top, in this order, ahead of the alphabetical rest. */
const PINNED_TENANTS = ['water-platform'];

/**
 * Comparator for tenant slugs: pinned ones first in their declared order, then alphabetical.
 *
 * @example
 * ['sonar-print', 'water-platform', 'dataoris'].sort(compareTenantSlugs)
 * // ['water-platform', 'dataoris', 'sonar-print']
 */
export function compareTenantSlugs(a: string, b: string): number {
  const rankA = PINNED_TENANTS.indexOf(a);
  const rankB = PINNED_TENANTS.indexOf(b);

  // Both pinned: keep the declared order.
  if (rankA !== -1 && rankB !== -1) return rankA - rankB;
  if (rankA !== -1) return -1;
  if (rankB !== -1) return 1;

  return a.localeCompare(b);
}
